import s from './Badge.module.css';

export default function Badge({ variant = 'neutral', children, className = '', ...rest }) {
  const cls = [s.badge, variant !== 'neutral' ? s[variant] : ''].filter(Boolean).join(' ');
  return (
    <span className={`${cls} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
